import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  SimpleGrid,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";

import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import JoditEditor from "jodit-react";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContatoType } from "models/contato_type";
import { EntregavelItem } from "models/entregavel_itens_type";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import { NotaRodape } from "models/nota_rodape_type";
import { OrderType } from "models/order_type";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";
import { MdAdd, MdEdit } from "react-icons/md";
import OrderContact from "./OrderContact";

interface IOrderData {
  error: boolean;
  brandStars: any;
  textColor: string;
  accountSelected: OrderType | undefined;
  onChangeClient: (client: string) => void;
  clients: PessoaType[] | undefined;
  agency: PessoaType[] | undefined;
  onChangeAgency: (ag: string) => void;
  calculaTotalOrder: (valor: number) => void;
  showCadastraraMidia: (show: boolean) => void;
  showCadastrarEntregavel: (show: boolean) => void;
  selectedClient: PessoaType | undefined;
  selectedAgency: PessoaType | undefined;
  changeInput: (tipo: string, value: string) => void;
  usuario: UsuarioModel | undefined;
  filiais: PessoaType[] | undefined;
  onChangeFilial: (filial: any) => void;
  selectedFilial: PessoaType | undefined;
  showAgenciaInputModal: (show: boolean) => void;
  showAgenciaInput: boolean;
  condicaoPagamento: CondicaoPagamento[] | undefined;
  modeloNegocio: ModeloNegocioType[] | undefined;
  onChangeModeloNegocio: (modelo: string) => void;
  onChangePagamento: (pagamento: string) => void;
  selectedCondicaoPagamento: CondicaoPagamento | undefined;
  selectedModeloNegocio: ModeloNegocioType | undefined;
  entregavel: ClientClassificationType[] | undefined;
  midias: ClientClassificationType[] | undefined;
  onChangeEntregavel: (et: any) => void;
  onChangeMidias: (midia: any) => void;
  selectedEntregaveis: EntregavelItem[] | undefined;
  selectedMidias: ClientClassificationType[] | undefined;
  data: Date;
  validade: Date;
  contatoAgencia: string;
  emailAgencia: string;
  telefoneAgencia: string;
  listContatoAgencia: ContatoType[];
  contatoCliente: string;
  emailCliente: string;
  telefoneCliente: string;
  listContatoCliente: ContatoType[];
  descricao: string;
  filteredClients: PessoaType[] | undefined;
  filteredAgency: PessoaType[] | undefined;
  changeFootNotes: (notes: string) => void;
  footNotes: NotaRodape[] | undefined;
  selectedFootNote: NotaRodape | undefined;
  changeCadastroDescricao: (notes: string) => void;
  descricoes: NotaRodape[] | undefined;
  selectedCadastro: NotaRodape | undefined;
  showContatoModal: (show: boolean, type: string) => void;
  showContactModal: boolean;
  editContact: (type: string) => void;
  saveContact: (type: string, action: string) => void;
  selectedContact: ContatoType | undefined;
  changeType: (type: string) => void;
  type: string;
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
}

const OrderData = ({
  brandStars,
  textColor,
  accountSelected,
  onChangeClient,
  error,
  onChangeAgency,
  selectedAgency,
  selectedClient,
  changeInput,
  usuario,
  filiais,
  onChangeFilial,
  calculaTotalOrder,
  selectedFilial,
  showAgenciaInput,
  showAgenciaInputModal,
  condicaoPagamento,
  modeloNegocio,
  onChangeModeloNegocio,
  onChangePagamento,
  selectedCondicaoPagamento,
  selectedModeloNegocio,
  entregavel,
  midias,
  onChangeEntregavel,
  onChangeMidias,
  selectedMidias,
  data,
  validade,
  showCadastraraMidia,
  showCadastrarEntregavel,
  contatoAgencia,
  emailAgencia,
  telefoneAgencia,
  contatoCliente,
  emailCliente,
  telefoneCliente,
  listContatoAgencia,
  listContatoCliente,
  filteredClients,
  filteredAgency,
  changeFootNotes,
  footNotes,
  selectedFootNote,
  changeCadastroDescricao,
  descricoes,
  selectedCadastro,
  changeType,
  editContact,
  saveContact,
  selectedContact,
  showContactModal,
  showContatoModal,
  type,
  showFormPessoa,
  editPessoa,
}: IOrderData) => {
  const [listaEntregavel, setListaEntregavel] = useState<EntregavelItem[]>([]);
  const [selectedEntregavel, setSelectedEntregavel] =
    useState<ClientClassificationType>(null);

  const onChangeEntregaveis = (value: string) => {
    const list: EntregavelItem[] = listaEntregavel;
    const existe = entregavel?.find((valor) => valor.id === value);

    const item: EntregavelItem = {
      id: existe?.id,
      orcamentoId: 0,
      entregavelId: existe?.id,
      nome: existe?.nome,
      quantidade: 0,
      descricao: "",
    };

    list.push(item);
    setSelectedEntregavel(existe);
    onChangeEntregavel(list);
    setListaEntregavel(list);
  };

  const changeItem = (item: EntregavelItem, index: number) => {
    const newItems: EntregavelItem[] = listaEntregavel.map(
      (existingItem, idx) => {
        if (index === idx) {
          return item;
        }
        return existingItem;
      }
    );
    onChangeEntregavel(newItems);
    setListaEntregavel(newItems);
  };

  const editItem = (data: EntregavelItem, value: string, index: number) => {
    const val = listaEntregavel[index];
    val.quantidade = Number(value);
    data = val;
    changeItem(data, index);
  };

  const deleteItem = (data: EntregavelItem, index: number) => {
    const newItems: EntregavelItem[] = listaEntregavel.filter(
      (item, idx) => index !== idx
    );
    onChangeEntregavel(newItems);
    setListaEntregavel(newItems);
  };

  const editDescricao = (
    data: EntregavelItem,
    value: string,
    index: number
  ) => {
    const val = listaEntregavel[index];
    val.descricao = value;
    data = val;
    changeItem(data, index);
  };

  const changeClient = (item: string) => {
    const filter = listContatoCliente.find((data) => data.id === item);
    if (filter) {
      changeInput("contatoCliente", filter?.id);
      changeInput("emailCliente", filter?.email);
      changeInput("telefoneCliente", filter?.telefone);
    } else {
      changeInput("contatoCliente", "");
      changeInput("emailCliente", "");
      changeInput("telefoneCliente", "");
    }
  };

  const changeAgencia = (item: string) => {
    const filter = listContatoAgencia.find((data) => data.id === item);
    if (filter) {
      changeInput("contatoAgencia", filter?.id);
      changeInput("emailAgencia", filter?.email);
      changeInput("telefoneAgencia", filter?.telefone);
    } else {
      changeInput("contatoAgencia", "");
      changeInput("emailAgencia", "");
      changeInput("telefoneAgencia", "");
    }
  };

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const editor1 = useRef(null);
  const editor2 = useRef(null);
  const item = useRef(null);

  useEffect(() => {
    if (accountSelected) {
      const listaItem: EntregavelItem[] = [];
      accountSelected?.EntregavelItens?.forEach((et) => {
        const addItem: EntregavelItem = {
          id: et.id,
          nome: entregavel.find((a) => a.id === et.entregavelId)?.nome,
          entregavelId: et.entregavelId,
          orcamentoId: et.orcamentoId,
          quantidade: et.quantidade,
          descricao: et.descricao,
        };
        listaItem.push(addItem);
      });
      setListaEntregavel(listaItem);
    }
    setTimeout(() => {
      item.current.focus();
    }, 0);
  }, [accountSelected, entregavel, filiais]);

  return (
    <form>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box
              flex="1"
              textAlign="left"
              color={"#422AFB"}
              fontWeight={"bold"}
            >
              Dados do Orçamento
            </Box>
            <AccordionIcon color={"#422AFB"} />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <SimpleGrid columns={3} spacing={2}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nome do Projeto<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                isInvalid={error}
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o Nome do Projeto"
                fontWeight="500"
                defaultValue={accountSelected?.nome}
                size="md"
                ref={item}
                autoFocus={true}
                onBlur={(e) => changeInput("nome", e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Data<Text color={brandStars}>*</Text>
              </FormLabel>

              <SingleDatepicker
                name="date-input"
                configs={{
                  dateFormat: "dd/MM/yyyy",
                  dayNames: "DSTQQSS".split(""), // length of 7
                  monthNames:
                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                      " "
                    ), // length of 12
                  firstDayOfWeek: 0,
                  // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                }}
                propsConfigs={{
                  dayOfMonthBtnProps: {
                    selectedBtnProps: {
                      background: "#422afb",
                      color: "white",
                    },
                  },
                }}
                date={data}
                onDateChange={(date: any) => {
                  changeInput("data", date);
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Status
              </FormLabel>

              <Select
                size="md"
                defaultValue={accountSelected?.status}
                onChange={(e) => changeInput("status", e.target.value)}
              >
                <option value="1">ABERTO</option>
                <option value="2">EM NEGOCIAÇÃO</option>
                <option value="3">APROVADO</option>
                <option value="4">EM PRODUÇÃO</option>
                <option value="5">CONCLUÍDO</option>
                <option value="6">DECLINADO</option>
                <option value="7">VENCIDO</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Responsável Orçamento
              </FormLabel>
              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Usuário"
                fontWeight="500"
                size="md"
                disabled={true}
                defaultValue={usuario?.nome}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nível de Acesso Orçamento
              </FormLabel>

              <Select size="md">
                <option value="1">SEM PERMISSÕES</option>
                <option value="2">EDIÇÃO</option>
                <option value="3">CRIAR VERSÕES</option>
                <option value="3">CONTROLE TOTAL</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Empresa Saída/Filial
              </FormLabel>

              <Select size="md"
              onChange={(e) => onChangeFilial(e.target.value)}
              defaultValue={accountSelected?.empresaSaiadaId}
              >
                <option value={"0"}>NENHUMA</option>
                {filiais?.map((item) => (
                  <option value={item.id}>{item.nome}</option>
                ))}
              </Select>


            </FormControl>

            <Checkbox
              colorScheme="brand"
              mb={4}
              defaultChecked={showAgenciaInput}
              onChange={(e) => showAgenciaInputModal(e.target.checked)}
            >
              Orçamento para a Agência?
            </Checkbox>
          </SimpleGrid>
          {showAgenciaInput && (
            <SimpleGrid columns={4} spacing={2}>
              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Agência
                </FormLabel>

                <Box w={"76%"}>
                  <AutoComplete<OptionType, false, GroupBase<OptionType>>
                    size="md"
                    isInvalid={error}
                    isRequired={true}
                    onChange={(e) => onChangeAgency(e.value)}
                    placeholder="Busque a Agência"
                    name={"agencia"}
                    options={filteredAgency?.map((item) => {
                      return {
                        label: item.nome,
                        value: item.id,
                      };
                    })}
                    defaultValue={{
                      label:
                        accountSelected?.agencia?.nome ?? selectedAgency?.nome,
                      value: accountSelected?.agencia?.id ?? selectedAgency?.id,
                    }}
                  />
                </Box>

                <IconButton
                  colorScheme="brand"
                  variant="solid"
                  mt={-10}
                  borderRadius={8}
                  icon={<MdAdd />}
                  onClick={() => showFormPessoa(true)}
                  float={"right"}
                  mr={12}
                  aria-label={"Adicionar Cliente"}
                />
                <IconButton
                  colorScheme="brand"
                  variant="solid"
                  mt={-10}
                  borderRadius={8}
                  icon={<MdEdit />}
                  onClick={() => {
                    editPessoa(selectedAgency);
                  }}
                  float={"right"}
                  aria-label={"Editar Contato"}
                />
              </FormControl>

              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Nome do Contato da Agência
                </FormLabel>
                <Box w={"76%"}>
                  <Select
                    value={contatoAgencia}
                    isInvalid={error}
                    isRequired={true}
                    size="md"
                    onChange={(e) => changeAgencia(e.target.value)}
                  >
                    <option value={null}>Selecione o Contato</option>
                    {listContatoAgencia?.map((item) => (
                      <option value={item.id}>{item.nome}</option>
                    ))}
                  </Select>
                </Box>
                <IconButton
                  colorScheme="brand"
                  variant="solid"
                  mt={-10}
                  borderRadius={8}
                  icon={<MdEdit />}
                  onClick={() => {
                    changeType("ag");
                    editContact("ag");
                  }}
                  float={"right"}
                  aria-label={"Editar Contato"}
                />
                <IconButton
                  colorScheme="brand"
                  variant="solid"
                  mt={-10}
                  borderRadius={8}
                  icon={<MdAdd />}
                  onClick={() => {
                    changeType("ag");
                    showContatoModal(true, "ag");
                  }}
                  float={"right"}
                  mr={12}
                  aria-label={"Adicionar Contato"}
                />
              </FormControl>

              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Email do Contato da Agência
                </FormLabel>

                <Input
                  isInvalid={error}
                  isRequired={true}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Email do Contato da Agência"
                  fontWeight="500"
                  size="md"
                  disabled={false}
                  onChange={(e) => changeInput("emailAgencia", e.target.value)}
                  value={emailAgencia}
                />
              </FormControl>

              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Telefone do Contato da Agência
                </FormLabel>

                <Input
                  isInvalid={error}
                  isRequired={true}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder=" Telefone do Contato da Agência"
                  fontWeight="500"
                  size="md"
                  disabled={false}
                  onChange={(e) =>
                    changeInput("telefoneAgencia", e.target.value)
                  }
                  value={telefoneAgencia}
                />
              </FormControl>
            </SimpleGrid>
          )}

          <SimpleGrid columns={4} spacing={2} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Cliente
              </FormLabel>

              <Box w={"76%"}>
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size="md"
                  onChange={(e) => onChangeClient(e.value)}
                  placeholder="Busque o Cliente"
                  isInvalid={error}
                  isRequired={true}
                  name={"cliente"}
                  options={filteredClients?.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                  defaultValue={{
                    label: selectedClient?.nome,
                    value: selectedClient?.id,
                  }}
                />
              </Box>

              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                mr={12}
                icon={<MdAdd />}
                onClick={() => showFormPessoa(true)}
                float={"right"}
                aria-label={"Adicionar Cliente"}
              />
              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                icon={<MdEdit />}
                onClick={() => {
                  editPessoa(selectedClient);
                }}
                float={"right"}
                aria-label={"Editar Contato"}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nome do Contato do Responsável do Cliente
              </FormLabel>
              <Box w={"76%"}>
                <Select
                  value={contatoCliente}
                  isInvalid={error}
                  isRequired={true}
                  size="md"
                  onChange={(e) => changeClient(e.target.value)}
                >
                  <option value={null}>Selecione o Contato</option>
                  {listContatoCliente?.map((contato) => (
                    <option value={contato.id}>{contato.nome}</option>
                  ))}
                </Select>
              </Box>
              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                icon={<MdEdit />}
                onClick={() => {
                  changeType("client");
                  editContact("client");
                }}
                float={"right"}
                aria-label={"Editar Contato"}
              />
              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                icon={<MdAdd />}
                onClick={() => {
                  changeType("client");
                  showContatoModal(true, "client");
                }}
                float={"right"}
                mr={12}
                aria-label={"Adicionar Contato"}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email do Contato do Cliente
              </FormLabel>

              <Input
                isInvalid={error}
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder=" Email do Contato do Cliente"
                fontWeight="500"
                size="md"
                disabled={false}
                onChange={(e) => changeInput("emailCliente", e.target.value)}
                value={emailCliente}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Telefone do Contato do Cliente
              </FormLabel>

              <Input
                isInvalid={error}
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder=" Email do Contato do Cliente"
                fontWeight="500"
                size="md"
                disabled={false}
                onChange={(e) => changeInput("telefoneCliente", e.target.value)}
                value={telefoneCliente}
              />
            </FormControl>
          </SimpleGrid>

          <SimpleGrid columns={4} spacing={2} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Modelo de Negócio
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => onChangeModeloNegocio(e.value)}
                placeholder="Busque o Modelo de Negócio"
                name={"modelo negocio"}
                options={modeloNegocio?.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                value={{
                  label: selectedModeloNegocio?.nome,
                  value: selectedModeloNegocio?.id,
                }}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Condição de Pagamento
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => onChangePagamento(e.value)}
                placeholder="Busque a Forma de Pagamento"
                name={"formaPagametno"}
                options={condicaoPagamento?.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                value={{
                  label: selectedCondicaoPagamento?.nome,
                  value: selectedCondicaoPagamento?.id,
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Validade da Proposta<Text color={brandStars}>*</Text>
              </FormLabel>
              <SingleDatepicker
                name="date-input-validade"
                configs={{
                  dateFormat: "dd/MM/yyyy",
                  dayNames: "DSTQQSS".split(""), // length of 7
                  monthNames:
                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                      " "
                    ), // length of 12
                  firstDayOfWeek: 0,
                  // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                }}
                propsConfigs={{
                  dayOfMonthBtnProps: {
                    selectedBtnProps: {
                      background: "#422afb",
                      color: "white",
                    },
                  },
                }}
                date={validade}
                onDateChange={(date: any) => {
                  changeInput("validade", date);
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Periodo de Veiculação - Informe em Meses
                <Text color={brandStars}>*</Text>
              </FormLabel>
              <NumberInput
                precision={0}
                step={3}
                max={24}
                min={1}
                defaultValue={accountSelected?.periodoVeiculacao}
                onChange={(e: string) => changeInput("periodoVeiculacao", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </SimpleGrid>

          <SimpleGrid columns={1} spacing={2} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Mídias/Veiculos
              </FormLabel>

              <Box w={"96%"}>
                <AutoComplete<OptionType, true, GroupBase<OptionType>>
                  size="md"
                  onChange={(e) => {
                    onChangeMidias(e);
                  }}
                  placeholder="Selecione as Midias"
                  name={"midias"}
                  tagVariant="solid"
                  colorScheme="brand"
                  isMulti
                  value={selectedMidias?.map((midia) => {
                    return {
                      label: midia.nome,
                      value: midia.id,
                    };
                  })}
                  options={midias?.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                />
              </Box>

              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                icon={<MdAdd />}
                onClick={() => showCadastraraMidia(true)}
                float={"right"}
                aria-label={"Adicionar Mídia"}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Entregáveis
              </FormLabel>

              <Box w={"96%"}>
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size="md"
                  onChange={(e) => {
                    onChangeEntregaveis(e.value);
                  }}
                  placeholder="Selecione os Entregáveis"
                  name={"entregaveis"}
                  tagVariant="solid"
                  colorScheme="brand"
                  options={entregavel?.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                  value={{
                    label: selectedEntregavel?.nome,
                    value: selectedEntregavel?.id,
                  }}
                />
              </Box>

              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                icon={<MdAdd />}
                onClick={() => showCadastrarEntregavel(true)}
                float={"right"}
                aria-label={"Adicionar Entregável"}
              />
            </FormControl>

            <Table variant="striped" color="gray.500" mb="24px" mt="12px">
              <Thead>
                <Tr>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #ENTREGÁVEL
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #QUANTIDADE
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #DESCRICAO
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #OPÇÕES
                    </Flex>
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {listaEntregavel?.map((item, idx) => {
                  return (
                    <Tr key={`${item.id}-${item}-${idx}`}>
                      <Td
                        fontSize={{ sm: "14px" }}
                        borderColor="transparent"
                        color={"black"}
                      >
                        {item.nome}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          isRequired={false}
                          fontSize="sm"
                          defaultValue={item.quantidade}
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="qtd"
                          fontWeight="500"
                          border={"none"}
                          name={`quantidade-${item.id}`}
                          size="md"
                          onBlur={(e) => {
                            editItem(item, e.target.value, idx);
                          }}
                        />
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          isRequired={false}
                          fontSize="sm"
                          defaultValue={item.descricao}
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="descricao"
                          fontWeight="500"
                          border={"none"}
                          name={`descricao-${item.id}`}
                          size="md"
                          onBlur={(e) => {
                            editDescricao(item, e.target.value, idx);
                          }}
                        />
                      </Td>
                      <Td>
                        <Button
                          onClick={() => {
                            deleteItem(item, idx);
                          }}
                          colorScheme="red"
                          variant="ghost"
                          ml="1"
                        >
                          Excluir
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </SimpleGrid>

          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={textColor}
          >
            Descrições de Orçamento<Text color={brandStars}>*</Text>
          </FormLabel>

          <SimpleGrid columns={4} mb={4}>
            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mt={4}
                color={textColor}
              ></FormLabel>
              <Select
                onChange={(e) => changeCadastroDescricao(e.target.value)}
                defaultValue={descricoes[0]?.id}
              >
                {descricoes?.map((desc) => (
                  <option value={desc.id}>{desc.nome}</option>
                ))}
              </Select>
            </FormControl>
          </SimpleGrid>

          <JoditEditor
            ref={editor1}
            value={
              selectedCadastro !== null
                ? selectedCadastro?.descricao
                : descricoes[0]?.descricao
            }
            config={{
              buttons: [
                "source",
                "|",
                "bold",
                "strikethrough",
                "underline",
                "italic",
                "|",
                "ul",
                "ol",
                "|",
                "outdent",
                "indent",
                "|",
                "font",
                "fontsize",
                "brush",
                "paragraph",
                "|",
                "image",
                "video",
                "table",
                "link",
                "|",
                "align",
                "undo",
                "redo",
                "|",
                "hr",
                "eraser",
                "copyformat",
                "|",
                "symbol",
                "fullsize",
                "print",
                "about",
              ],
              buttonsXS: [
                "bold",
                "image",
                "|",
                "brush",
                "paragraph",
                "|",
                "align",
                "|",
                "undo",
                "redo",
                "|",
                "eraser",
                "dots",
              ],
              readonly: false,
            }}
            onBlur={(newContent) => {
              changeInput("descricao", newContent);
            }}
          />

          <SimpleGrid columns={4} mb={4}>
            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mt={4}
                color={textColor}
              >
                Notas de Rodapé
              </FormLabel>
              <Select
                onChange={(e) => changeFootNotes(e.target.value)}
                defaultValue={footNotes[0]?.id}
              >
                {footNotes?.map((note) => (
                  <option value={note.id}>{note.nome}</option>
                ))}
              </Select>
            </FormControl>
          </SimpleGrid>

          <JoditEditor
            ref={editor2}
            value={
              selectedFootNote !== null
                ? selectedFootNote?.descricao
                : footNotes[0]?.descricao
            }
            config={{
              buttons: [
                "source",
                "|",
                "bold",
                "strikethrough",
                "underline",
                "italic",
                "|",
                "ul",
                "ol",
                "|",
                "outdent",
                "indent",
                "|",
                "font",
                "fontsize",
                "brush",
                "paragraph",
                "|",
                "image",
                "video",
                "table",
                "link",
                "|",
                "align",
                "undo",
                "redo",
                "|",
                "hr",
                "eraser",
                "copyformat",
                "|",
                "symbol",
                "fullsize",
                "print",
                "about",
              ],
              buttonsXS: [
                "bold",
                "image",
                "|",
                "brush",
                "paragraph",
                "|",
                "align",
                "|",
                "undo",
                "redo",
                "|",
                "eraser",
                "dots",
              ],
              readonly: false,
            }}
            onBlur={(newContent) => {
              changeInput("notasRodape", newContent);
            }}
          />

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mt={8}
              mb="8px"
            >
              Nome da Versão<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isInvalid={error}
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Nome da Versão"
              fontWeight="500"
              defaultValue={accountSelected?.nomeVersao}
              size="md"
              onBlur={(e) => changeInput("nomeVersao", e.target.value)}
            />
          </FormControl>

          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mt={4}
              color={textColor}
            >
              Notas da versão<Text color={brandStars}>*</Text>
            </FormLabel>
            <Textarea
              defaultValue={accountSelected?.notas}
              fontSize="sm"
              height={200}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Preencha as notas"
              onBlur={(e) => changeInput("notas", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <OrderContact
            changeInput={changeInput}
            loading={false}
            save={saveContact}
            selectedContact={selectedContact}
            show={showContactModal}
            showModal={showContatoModal}
            type={type}
          />
        </AccordionPanel>
      </AccordionItem>
    </form>
  );
};
export default OrderData;
